var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isGrouped)?_c('EnrollmentTool',{attrs:{"smsNumber":_vm.params.data.sms,"enrollmentId":_vm.params.data.enrollmentid,"enrollmentStatus":_vm.params.data.enrollmentstatus || 'notEnrolled',"beneficiaryId":_vm.params.data.beneficiaryid,"beneficiaryLastName":_vm.params.data.benelastname}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }